import {
  Skeleton,
  Stack,
  Image,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'

import UploadContents from './components/Contents'
import { useUploadImage } from './context/Provider'
import ImageCard from './components/ImageCard'

export default function UploadImageComponent() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { size, rounded, image, isLoading } = useUploadImage()

  return (
    <>
      <Stack position="relative">
        {image.url ? (
          <Box rounded={rounded} borderWidth="2px" borderColor="primary">
            <Skeleton rounded={rounded} w={size} h={size} isLoaded={!isLoading}>
              <Image
                loading="lazy"
                objectFit="cover"
                height={size}
                rounded={rounded}
                src={image.url}
                alt="Imagem dinâmica"
                cursor="pointer"
                onClick={onOpen}
              />
            </Skeleton>
          </Box>
        ) : (
          <ImageCard />
        )}

        <UploadContents />
      </Stack>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton size={'lg'} />
          <ModalBody display="flex" justifyContent="center">
            <Image src={image.url} alt="Foto do usuário" maxH="80vh" maxW="80vw" borderRadius="lg" shadow="lg" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
